import * as React from "react";
import { useState, useContext, createContext, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import { DateField }  from "~common/components/fields/date-field-fc";
import {cloneDeep} from 'lodash'
import {Grid} from '@mui/material';

export const FromDateContext = createContext();
export const ToDateContext = createContext();

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      width: "100%",
    },
  })
);

interface DateRangeProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}

export const DateRangeField: React.FC<DateRangeProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setFieldVal will pass the value up to the parent component that houses the context.

  const [fieldVal, setFieldVal] = useContext(ValueContext);



  var fromPropsVal = null 
  var toPropsVal = null 
  
  if (fieldVal) {
    if (fieldVal.from) {
      fromPropsVal = fieldVal.from;
    }
    if (fieldVal.to) {
      toPropsVal = fieldVal.to;
    } 
  }


  const [localFromVal, setLocalFromVal] = useState(fromPropsVal);
  const [localToVal, setLocalToVal] = useState(toPropsVal);

  const filterPolicyMessages = (policyMessages, subField) => {
    if (policyMessages) {

      const applicable = policyMessages.reduce((acc, m): Array<any> => {
        if (m && m.extendedAttributes ) {
          if (m.extendedAttributes[subField] == true) {
            acc.push(m);
          }
        }

        return acc;
      }, []);
      
      return applicable
    } else {
      return null
    }
  };

  var fromPolicyMessages = filterPolicyMessages(policyMessages, "from");
  var toPolicyMessages = filterPolicyMessages(policyMessages, "to");

  const fieldValChanged = (): boolean => {

    var _fieldVal = cloneDeep(fieldVal)

    if (!_fieldVal) {
      _fieldVal = {}
    }

    if (_fieldVal.to != localToVal) {
      return true
    }
    if (_fieldVal.from != localFromVal) {
      return true
    }

    return false
  }

  useEffect(() => {
      var newVal = {"from": localFromVal, "to": localToVal} 
      if (fieldValChanged()) {
        setFieldVal(newVal);
      }
  }, [localFromVal, localToVal])
  
  useEffect(() => {
    if (fieldVal) {
      setLocalFromVal(fieldVal.from);
      setLocalToVal(fieldVal.to);
    } else {
      setLocalFromVal(null);
      setLocalToVal(null);
    }

  }, [fieldVal])

   var fromDef = cloneDeep(fieldDefinition)
   if (fieldDefinition.rangeFieldTitle) {
    fromDef.title = fieldDefinition.rangeFieldTitle.from
   } else {
    fromDef.title = fieldDefinition.title + " From"
   }
   fromDef.key = fieldDefinition.key + "From"

   var toDef = cloneDeep(fieldDefinition)
   if (fieldDefinition.rangeFieldTitle) {
    toDef.title = fieldDefinition.rangeFieldTitle.to
   } else {
    toDef.title = fieldDefinition.title + " To"
   }
   toDef.key = fieldDefinition.key + "To"
    
  return (
    <Grid container spacing={1}>
      <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>

        {/* From Date */}
      <FromDateContext.Provider value={[localFromVal, setLocalFromVal]}>
      <DateField
        fieldDefinition={fromDef}
        policyMessages={fromPolicyMessages}
        readOnlyOverride={readOnlyOverride}
        contextType={"from"}
      />
      </FromDateContext.Provider>
      </Grid>
      <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>

      {/* To Date */}
      <ToDateContext.Provider value={[localToVal, setLocalToVal]}>
      <DateField
        fieldDefinition={toDef}
        policyMessages={toPolicyMessages}
        readOnlyOverride={readOnlyOverride}
        contextType={"to"}
      />
      </ToDateContext.Provider>


      </Grid>
    </Grid>
  )

};

export default DateRangeField;
